import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { SessionInfoSingleton } from "../data/singleton/session-info.singleton";
import { SessionService } from "../services/session.service";

/**
 * パス「/login」以下のAPIに関するクラス
 */
@Injectable({
  providedIn: "root",
})
export class LoginApi {
  /**
   * コンストラクタ
   */
  constructor(
    private httpClient: HttpClient,
    private sessionInfoSingleton: SessionInfoSingleton
  ) {}

  /** GET */
  /**
   * ログイン・ログアウトログの記録
   * - APIパス：/login/${loginId}/${type}
   * @param loginId: ログインID
   * @param type: ログインorログアウト、ログイン：1／ログアウト：0
   * @returns Observable<Object>型のレスポンス
   */
  recordingLoginLogoutLog(loginId: string, type: string): Observable<Object> {
    const url = `${environment.apiUrl}/login/${loginId}/${type}`;

    return this.httpClient.get(url, {
      headers: new HttpHeaders({
        Authorization: this.sessionInfoSingleton.getIdToken(),
        "Content-Type": "application/json",
      }),
    });
  }
}
